export function buildKeyword(config) {
    return {
        toQuerySyntax() {
            const { expression, negate } = config;
            return negate ? `NOT (${expression})` : expression;
        },
    };
}
